<template>
  <div class="produce_">
    <div class="page-banner">
      <!-- <img src="../assets/pcImg/gamebanner.jpg" alt /> -->
      <img :src="subBannerImgurl" alt />
    </div>
    <div class="producu_body">
      <!-- <div class="produce_title">{{$t('m.products.gm')}}</div> -->
      <div class="pro_area animate__animated animate__fadeInUp">
        <div class="pro_center">
          <div class="pro_item pro_l" :class="tabs == 0 ? 'active' : ''" @click="tab(0)">
            <i></i>
            精品游戏
          </div>
          <div class="pro_item pro_r" :class="tabs == 1 ? 'active' : ''" @click="tab(1)">
            <i></i>
            游戏视频
          </div>
        </div>
      </div>

      <div class="produce_list mar7" v-if="tabs == 0">
        <div class="produce_list_item animate__animated animate__fadeInUp" v-for="item in highList" :key="item.id">
          <router-link :to="'/gamesDetail/' + item.id">
            <i></i>
            <img :src="item.center_img" class="pro_img" alt />
            <div class="pro_infor">
              <p class="name ellipsis-one">{{ item.name }}</p>
            </div>
          </router-link>
        </div>
      </div>

      <div class="video_list" v-if="tabs == 1">
        <div class="produce_recom_game animate__animated animate__fadeInUp">
          <div class="produce_fl">
            <i></i>
            <em @click="play(recomGame.video_path)"></em>
            <img :src="recomGame.video_img" alt width="100%" />
          </div>
          <div class="produce_fr">
            <p class="title">{{ recomGame.video_name}}</p>
            <p class="desc">{{recomGame.video_desc}}</p>
          </div>
        </div>

        <div class="video_list_item animate__animated animate__fadeInUp" v-for="item in newArr" :key="item.id">
          <i></i>
          <em @click="play(item.video_path)"></em>
          <img :src="item.video_img" class="pro_img" alt />
          <div class="pro_infor">
            <p class="name ellipsis-one">{{ item.video_name }}</p>
          </div>
        </div>

        <template>
          <div class="video_frame animate__animated animate__fadeInUp" v-if="options.isVideoIframe">
            <i @click="closeVideoDialog"></i>
            <video ref="myVideo" controls>
              <source :src="video_url" type="video/mp4" />Sorry, your browser doesn't support embedded
              videos.
            </video>
          </div>
        </template>
      </div>
    </div>
    <loading v-if="loading" class="loading"></loading>
    <common-mask :options="options" @closeVideoDialog="closeVideoDialog"></common-mask>

    <!-- <div class="mark_" v-show="mark" :style="{ height: clientHeights }">
            <img src="../assets/pcImg/game3.png" alt class="mark_bg" />
            <div class="game_comtent">
                <img
                    src="../assets/pcImg/close1.png"
                    alt
                    class="close"
                    v-on:click="closeMark()"
                />
                <div class="title">{{ gameName }}</div>
                <div class="all_content">
                    <div class="content_">题材：{{ gameTheme }}</div>
                    <div class="content_">类型：{{ gameType }}</div>
                    <div class="content_ line_height">
                        发行地区：{{ gameArea }}
                    </div>
                    <div class="content_ content_intro">{{ gameIntro }}</div>
                </div>
            </div>
    </div>-->
  </div>
</template>
<script>
import Loading from './loading'
import CommonMask from './CommonMask'
export default {
  components: {
    CommonMask,
    Loading,
  },
  data() {
    return {
      proList: [],
      mark: false,
      clientHeights: 0,
      tabs: 0,
      gameName: '',
      gameTheme: '',
      gameType: '',
      gameArea: '',
      gameIntro: '',
      options: {
        isMask: false,
        isLoading: false,
        isVideoShow: true,
        isVideoIframe: false,
      },
      pageSize: 200,
      recomGame: {},
      video_url: '',
      newArr: [],
      highList: [],
      subBannerImgurl: '',
      loading: true,
    }
  },
  mounted: function () {
    this.getHighList()
    this.getSubBannerImgurl()
    this.initGame(this.$i18n.locale)
    this.clientHeights =
      (document.documentElement.clientHeight || document.body.clientHeight) +
      'px'
  },
  methods: {
    initGame(e) {
      let datas = {
        lang: e,
      }
      this.getHttp(this, datas, '/front/product', function (obj, data) {
        obj.proList = data
      })
    },
    showMark(e) {
      this.mark = true
      this.gameName = e.name
      this.gameArea = e.publish_area
      this.gameIntro = e.intro
      this.gameTheme = e.theme
      this.gameType = e.type
    },
    closeMark() {
      this.mark = false
    },
    tab(e) {
      this.tabs = e
      if (e == 1) {
        this.getVideoList(1)
      }
    },
    getSubBannerImgurl: function () {
      let datas = {
        position: 2,
      }
      this.getHttp(this, datas, '/front/page/banner', function (obj, data) {
        if (data.status == 2000) {
          obj.subBannerImgurl = data.data[0].img_url
        }
        obj.loading = false
      })
    },
    getHighList: function (page) {
      let datas = {}
      this.getHttp(this, datas, '/front/game/list', function (obj, data) {
        let data_ = data.data
        obj.highList = data_
        obj.loading = false
      })
    },
    getVideoList: function (page) {
      let datas = {
        page: page,
        page_size: this.pageSize,
      }
      this.getHttp(this, datas, '/front/video/list', function (obj, data) {
        if (data.status == 2000) {
          let data_ = data.data.video_list
          obj.recomGame = data_[0]
          obj.newArr = data_.slice(1)
          console.log('游戏视频列表del', data_, obj.newArr)
        } else {
          console.log(data.message)
        }
        obj.loading = false
      })
    },
    play: function (e) {
      console.log('video', e)
      this.options.isMask = true
      this.options.isVideoIframe = true
      this.video_url = e
      this.$nextTick(() => {
        this.$refs.myVideo.play()
        this.stop()
      })
    },
    closeVideoDialog: function () {
      this.move()
      this.options.isMask = false
      this.options.isVideoIframe = false
    },
    stop() {
      document.body.style.overflow = 'hidden'
    },
    move() {
      document.body.style.overflow = ''
    },
  },
  computed: {
    getUserLangs() {
      //vue生命周期计算属性时返回对应的字体以便监听
      return this.$i18n.locale
    },
  },
  watch: {
    getUserLangs(val) {
      this.initGame(val)
    },
  },
}
</script>
<style lang="scss" scoped>
.produce_ {
  background: #1d222c;
}
.video_frame {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 99999;
  width: 960px;
  height: 540px;
  margin-top: -270px;
  margin-left: -480px;
  box-shadow: 0 0 0.8em #fff;

  video {
    width: 100%;
    height: 100%;
  }

  i {
    position: absolute;
    right: -32px;
    top: -32px;
    z-index: 2;
    height: 60px;
    width: 60px;
    cursor: pointer;
    text-align: center;
    line-height: 40px;
    color: #fff;
    font-weight: bold;
    font-size: 30px;
    font-style: normal;
    text-indent: -9999px;
    background: url('../assets/pcImg/video-close.png') no-repeat;
    transition: All 0.4s ease-in-out;
    -webkit-transition: All 0.4s ease-in-out;

    &:hover {
      transform: rotate(180deg);
    }
  }
}
.page-banner {
  width: 100%;
  height: 0;
  padding-bottom: 32.3%;
  position: relative;
  background: #1e232d;
}
.page-banner img {
  width: 100%;
}
.producu_body {
  position: relative;
  width: 100%;
  overflow-x: hidden;
  /**min-height: 16.22rem;**/
  background: url(../assets/pcImg/pro_bg.jpg) no-repeat;
  background-size: 100% 100%;
  .produce_title {
    width: 12rem;
    color: white;
    font-size: 0.36rem;
    position: absolute;
    top: 1.5rem;
    margin-left: -6rem;
    text-align: center;
    left: 50%;
    letter-spacing: 0px;
  }
  .produce_title::after {
    content: '';
    display: block;
    margin-left: 5rem;
    margin-top: 0.1rem;
    width: 2rem;
    height: 2px;
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0) 10%,
      rgba(251, 140, 76, 0.3) 20%,
      rgba(251, 140, 76, 0.4) 30%,
      rgba(251, 140, 76, 0.5) 40%,
      rgba(251, 140, 76, 0.8) 50%,
      rgba(251, 140, 76, 0.5) 60%,
      rgba(251, 140, 76, 0.4) 70%,
      rgba(251, 140, 76, 0.3) 80%,
      rgba(0, 0, 0, 0) 90%,
      rgba(0, 0, 0, 0) 100%
    );
  }
  .pro_area {
    width: 100%;
    height: 0.82rem;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-flow: row wrap;
    justify-content: start;
    background-image: linear-gradient(#3c3f51, #2f3542);
    .pro_center {
      position: absolute;
      width: 6.08rem;
      top: 0;
      left: 50%;
      margin-left: -3.04rem;
    }
    .pro_item {
      width: 2rem;
      height: 0.82rem;
      line-height: 0.82rem;
      font-size: 0.22rem;
      font-weight: blod;
      text-align: center;
      color: white;
      cursor: pointer;
      text-indent: 0.4rem;
      /**border: 1px solid #ef9313;
            cursor: pointer;
            transition: all 0.3s ease;**/
      i {
        display: inline-block;
        position: absolute;
        left: 50%;
        right: 50%;
        bottom: 0;
        width: 0;
        height: 3px;
        border-radius: 1.5px;
        transition: all 0.5s ease-out;
      }
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0.3rem;
      }
    }
    .pro_l {
      position: absolute;
      left: 0;
      &::before {
        width: 0.3rem;
        height: 0.3rem;
        margin-top: -0.15rem;
        background: url(../assets/pcImg/v1.png) no-repeat;
        background-size: 100% 100%;
      }
    }
    .pro_r {
      position: absolute;
      right: 0;
      &::before {
        width: 0.32rem;
        height: 0.32rem;
        margin-top: -0.16rem;
        background: url(../assets/pcImg/v2.png) no-repeat;
        background-size: 100% 100%;
      }
    }
    .pro_item:hover i {
      width: 100%;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: linear-gradient(to right, #d46237, #faa605);
      // background-color: #ef9313;
      // background-image: linear-gradient(to bottom, #faa605, #d46336);
    }
    .active i {
      width: 100%;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: linear-gradient(to right, #d46237, #faa605);
      // background-color: #ef9313;
      // background-image: linear-gradient(to bottom, #faa605, #d46336);
    }
  }
  .mar7 {
    margin-top: 1.77rem !important;
  }
  .produce_list,
  .video_list {
    display: flex;
    width: 12rem;
    margin: 0 auto;
    margin-top: 6.3rem;
    flex-flow: row wrap;
    .produce_recom_game {
      position: absolute;
      width: 12rem;
      left: 50%;
      margin-left: -6rem;
      top: 1.85rem;
      .produce_fl {
        position: relative;
        width: 6.33rem;
        height: 3.76rem;
        i {
          display: inline-block;
          position: absolute;
          width: 1.07rem;
          height: 0.97rem;
          left: 0;
          top: 0;
          z-index: 1;
          background: url(../assets/pcImg/recom.png) no-repeat;
          background-size: 100% 100%;
          transition: all 0.9s;
          vertical-align: middle;
          border-top-left-radius: 4px;
        }
        em {
          display: inline-block;
          position: absolute;
          width: 1.03rem;
          height: 1.03rem;
          left: 50%;
          top: 50%;
          margin-left: -0.515rem;
          margin-top: -0.515rem;
          z-index: 1;
          background: url(../assets/pcImg/play.png) no-repeat;
          background-size: 100% 100%;
          transition: all 0.9s;
          vertical-align: middle;
          cursor: pointer;
        }
        img {
          transition: all 0.9s;
          border-radius: 4px;
        }
      }
      .produce_fl:hover em {
        transform: scale(1.2);
      }
      .produce_fr {
        width: 4.8rem;
        position: absolute;
        top: 0;
        left: 6.84rem;
        .title {
          font-size: 0.24rem;
          color: #ffffff;
          margin: 30px auto 24px;
        }
        .desc {
          font-size: 0.1445rem;
          color: #ffffff;
        }
      }
    }
    .video_content {
      display: flex;
      width: 12rem;
      position: absolute;
      top: 3rem;
    }
    .produce_list_item,
    .video_list_item {
      position: relative;
      width: 3.76rem;
      height: 2.7rem;
      margin-bottom: 0.68rem;
      cursor: pointer;
      overflow: hidden;
      font-size: 0.1789rem;
      color: #141620;
      margin-right: 0.2rem;
      background: white;
      a {
        text-decoration: none;
      }
      i {
        display: inline-block;
        position: absolute;
        width: 100%;
        height: 3px;
        left: 0;
        bottom: 0;
        z-index: 1;
        background-image: linear-gradient(
          to right,
          #fe8d08,
          #34ee76,
          #00eaff,
          #8400ff
        );
      }
      em {
        display: inline-block;
        position: absolute;
        width: 0.65rem;
        height: 0.65rem;
        left: 50%;
        top: 50%;
        margin-left: -0.325rem;
        margin-top: -0.325rem;
        z-index: 1;
        background: url(../assets/pcImg/play.png) no-repeat;
        background-size: 100% 100%;
        transition: all 0.9s;
        vertical-align: middle;
        &:hover {
          transform: scale(1.2);
        }
      }
      img {
        width: 100%;
        height: 2.22rem;
        transition: all 0.8s ease;
      }
      .pro_infor {
        height: 0.7rem;
        width: 100%;
        text-align: center;
        font-size: 0.16rem;
        color: #a9a9ab;
        p {
          margin: 0;
        }
        .name {
          color: #141620;
          margin: 0.08rem 0.03rem 0.05rem;
          font-size: 0.16rem;
          font-weight: 600;
        }
        .informate {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0 10%;
        }
      }
    }
    .produce_list_item {
      width: 3.76rem;
      height: 2.74rem;
      margin-right: 0.36rem;
    }
    .produce_list_item img {
      height: 2.22rem;
    }
    .produce_list_item .pro_infor .name {
      font-size: 0.24rem;
    }
    .produce_list_item:hover,
    .video_list_item:hover {
      -webkit-box-shadow: 0 0 6px 0 rgba(81, 72, 68, 0.44);
      -moz-box-shadow: 0 0 6px 0 rgba(81, 72, 68, 0.44);
      -ms-box-shadow: 0 0 6px 0 rgba(81, 72, 68, 0.44);
      -o-box-shadow: 0 0 6px 0 rgba(81, 72, 68, 0.44);
      box-shadow: 0 0 6px 0 rgba(81, 72, 68, 0.44);
      img {
        -webkit-transform: scale(1.06, 1.06);
        -o-transform: scale(1.06, 1.06);
        -ms-transform: scale(1.06, 1.06);
        transform: scale(1.06, 1.06);
      }
    }
    .produce_list_item:nth-of-type(3n) {
      margin-right: 0;
    }
  }
}
.mark_ {
  width: 100%;
  background: rgba($color: #000, $alpha: 0.6);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1999;
  .mark_bg,
  .game_comtent {
    position: absolute;
    width: 7.84rem;
    height: 5.02rem;
    top: 50%;
    margin-top: -2.51rem;
    left: 50%;
    margin-left: -3.92rem;
  }
  .game_comtent {
    .close {
      position: absolute;
      width: 0.5rem;
      height: 0.5rem;
      right: 0.05rem;
      top: 0.05rem;
    }
    .close:hover {
      transform: rotate(360deg);
      transition: transform 1.5s ease-in-out;
    }
    .title {
      color: white;
      font-size: 0.49rem;
      margin-top: 0.6rem;
      text-align: center;
    }
    .all_content {
      width: 5.75rem;
      height: 2.04rem;
      position: absolute;
      left: 1.13rem;
      top: 1.73rem;
    }

    .content_ {
      width: 100%;
      text-align: left;
      color: white;
      font-size: 0.21rem;
      line-height: 0.5rem;
    }
    .line_height {
      line-height: 0.3rem;
    }
    .content_intro {
      line-height: 0.35rem;
      max-height: 1.4rem;
      overflow: auto;
    }
  }
}

::-webkit-scrollbar {
  width: 0.04rem;
  height: 0px;
}

/* 滚动条的滑轨背景颜色 */
::-webkit-scrollbar-track {
  background-color: #16182269;
  border-radius: 0.04rem;
}

/* 滑块颜色 */
::-webkit-scrollbar-thumb {
  background-color: #0c0e15;
  border-radius: 0.04rem;
}

/*内层轨道的颜色*/
::-webkit-scrollbar-track-piece {
  background-color: #16182269;
  border-radius: 0.08rem;
}

/* 滑轨两头的监听按钮颜色 */
::-webkit-scrollbar-button {
  background-color: #16182269;
  width: 0;
  height: 0;
}

/* 横向滚动条和纵向滚动条相交处尖角的颜色 */
::-webkit-scrollbar-corner {
  background-color: black;
}
</style>